
import { defineComponent, ref, onMounted } from 'vue'

import Skeleton from '@/components/UI/Skeleton.vue'
import { useI18n } from 'vue-i18n'

const imgSrc =
  'https://images.unsplash.com/photo-1593642634443-44adaa06623a?ixid=MXwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1225&q=80'

const fakeData = [
  {
    id: 1,
    desc: 'console.log(this.$refs.input1)//<input type="text" id="input1">'
  },
  {
    id: 2,
    desc: 'wqrwqniofdshnodfdj,fdsjfiod, Good for you!!'
  }
]

export default defineComponent({
  components: {
    Skeleton
  },
  setup () {
    const { t, locale } = useI18n()
    function changeLang () {
      locale.value = 'en'
    }

    const progressEl = ref<HTMLInputElement>()

    const textEl = ref<HTMLInputElement>()
    function copy () {
      console.log(textEl.value)
      console.log(document.getElementsByClassName('clipborad')[0])
      if (textEl.value) {
        const range = document.createRange()

        // const texts = textEl.value.innerHTML

        range.selectNode(textEl.value)

        const selection = window.getSelection()

        if (selection) {
          selection.removeAllRanges()
          selection.addRange(range)
          document.execCommand('copy')
          selection.removeAllRanges()
        }
      }
    }

    function copyToClipboard (text: string) {
      const el = document.createElement('textarea')
      el.addEventListener('focusin', e => e.stopPropagation())
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }

    function startProgress () {
      if (progressEl.value) {
        const computedStyle = getComputedStyle(progressEl.value)
        const width = parseFloat(
          computedStyle.getPropertyValue('--width') || '0'
        )
        progressEl.value.style.setProperty('--width', (width + 0.1).toString())
      }
    }

    onMounted(() => {
      const timeoutID = setInterval(() => {
        if (progressEl.value) {
          const computedStyle = getComputedStyle(progressEl.value)
          const width = parseFloat(
            computedStyle.getPropertyValue('--width') || '0'
          )
          progressEl.value.style.setProperty(
            '--width',
            (width + 0.1).toString()
          )

          if (width >= 99.9) {
            clearInterval(timeoutID)
          }
        }
      }, 10)
    })

    return {
      imgSrc,
      progressEl,
      startProgress,
      fakeData,
      t,
      changeLang,
      copy,
      textEl,
      copyToClipboard
    }
  }
})
